import React, {useEffect, useState} from "react";
import {
    Card,
    CardBody,
    CardTitle, Col,
    Form, Label, Row,
} from "reactstrap";
import {  useForm } from "react-hook-form";
import { connect } from "react-redux";
import * as Yup from "yup";

// components
import {
    ButtonCancel,
    ButtonSubmit,
} from "../../../components/buttons/buttonsActions";
import {DragList} from "../../../components/draggableList/DragList";
import {pointDraggableItemContent} from "../../../components/draggableList/renderContent";

// labels
import {
    FORM
} from "../../../components/i18n/i18n";

// actions
import { setLoading, setViewMode } from "../../../redux/actions/generalActions/mainActions";
import { resetCombos, setForm, setItem } from "../../../redux/actions/generalActions/formActions";
import { genericActions } from "../../../redux/actions/generics/GenericActions";

// services
import { mapFunctions } from "../../../components/map/mapFunctions";
import { activityService } from "../../../jwt/_services/core/activityService";
import { pointService } from "../../../jwt/_services/xeeker/pointService";
import MapController from "../../../components/map/MapController";


const ActivityAccessPoints = props => {
    const { udn, mapConfig } = props.mainProps;
    const { domainObject } = props.formProps;
    const fbDataBaseId = props.mainProps?.app?.fbDataBase?.id

    const [points, setPoints] = useState(domainObject?.accessPoints || []);
    const [markers, setMarkers] = useState(mapFunctions.mapPointsToMarkers(domainObject?.accessPoints || []));


    // Banderas
    const [ center ] = useState(domainObject?.latitude && domainObject?.longitude ? {
        id: domainObject.id,
        showOrder: -1,
        originalOrder: -1,
        position: { lat: parseFloat(domainObject?.latitude), lng : parseFloat(domainObject?.longitude) }
    } : {
        id: 'xxxxxxxx',
        showOrder: -1,
        originalOrder: -1,
        position: mapConfig?.center
    } );

    const validationSchema = Yup.object().shape({
        // code: Yup.string().required(REQUIRED).max(MAX_NAME_SIZE, MAX_NAME),
    });

    const {handleSubmit, reset} = useForm({
        validationSchema: validationSchema,
        defaultValues: {
        }
    });


    const onSubmit = (data, _) => {

        let dataRequest = {
            fbDataBase :  { id : fbDataBaseId },
            // El objeto item es de tipo Activity
            item : {
                id: domainObject.id,
                accessPoints : [...points]
            }
        };


        // console.log(dataRequest);

        let id = domainObject.id;
        dataRequest.item.id = id
        genericActions.update(activityService, id, dataRequest)
        closeForm()
    };

    const closeForm = () => {
        reset();
        props.setItem(null);
        props.setForm();
        props.onClose();
    }

    const onMarkerClick = (_marker) => {
        let _points = points.slice();
        const _newPoint = {
            id : _marker.id,
            lat: parseFloat(_marker.position.lat),
            lng : parseFloat(_marker.position.lng)
        }

        let _markers = markers.slice();
        let _newMarker = {
            id: _marker.id,
            showOrder: _markers.length,
            position: _marker.position
        }

        const ix = points.findIndex(n => n.id === _marker.id)
        if ( ix === -1 ) {
            _points.push(_newPoint);
            _markers.push(_newMarker);
        }

        if (_markers) {
            setMarkers(_markers);
            setPoints(_points);
        }
    }

    const searchNearest = (_radio) => {
        return getNearestPoints(udn, center.position, _radio);
    }

    const getNearestPoints = ( _udn, _point, _radio ) => {
        if (_udn?.id === undefined)
            return

        const dataRequest = {
            id : _point.id,
            lat : _point.lat,
            lng : _point.lng,
            ratio : _radio,
            udn : { id : _udn.id }
        }

        return pointService.searchNearest( dataRequest )
    }

    return (
        <>
            <Card className={'card-modal access-points-form'}>
                <CardTitle className="bg-light border-bottom p-3 mb-0">
                    <i className="far fa-edit mr-2"/>
                    {FORM}
                </CardTitle>

                <CardBody className={'card-body-modal'}>
                    <Form onSubmit={handleSubmit(onSubmit)}>
                        <Row className={""}>
                            {/*<Col md={ showPoints ? "8" : "12" } >*/}
                            <Col md={"8"} >
                                {
                                    mapConfig?.mapOptions !== undefined &&
                                    <MapController mode={'ACCESS_POINTS'}
                                                   googleMapConfig={mapConfig}
                                                   marker={center}
                                                   markers={markers}
                                                   searchNearest={searchNearest}
                                                   // onMapClick={onMapClick}
                                                   onMarkerClick={onMarkerClick}
                                                   // onClearMarkers={onClearMarkers}
                                                   // onAddConsec={onAddConsec}
                                                   // onAddPrev={onAddPrev}
                                                   // selectedMarker={selectedMarker}
                                                   updateMarkerPosition={true}
                                    />
                                }
                            </Col>
                            {/*{*/}
                            {/*    showPoints &&*/}
                                <Col md="4" className={'position-list'}>
                                    <Label>Puntos selecionados</Label>
                                    <DragList items={markers} renderContent={pointDraggableItemContent}
                                              onReorder={_ => {console.log('onReorder')}}
                                              onRemove={_ => {console.log('onRemove')}}
                                              onSelect={_ => {console.log('onSelect')}}
                                    />
                                </Col>
                            {/*}*/}
                        </Row>

                        <CardBody className="border-top">
                            <div className="float-right">
                                <ButtonSubmit/>
                                <ButtonCancel onClick={closeForm}/>
                            </div>
                        </CardBody>
                    </Form>
                </CardBody>
            </Card>
        </>
    )
}


const mapStateToProps = state => ({
    mainProps: state.mainProps,
    formProps: state.formProps,
})

const mapActionsToProps = ({
    setViewMode,
    resetCombos,
    setItem,
    setForm,
    setLoading
})

export default connect(mapStateToProps, mapActionsToProps)(ActivityAccessPoints)